import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthCard from "@/components/auth/AuthCard";
import AuthButton from "@/components/auth/AuthButton";
import AuthLink from "@/components/auth/AuthLink";
import { useAuth, formatAuthError } from "@/context/AuthContext";

export default function MagicLinkSent() {
  const { magicLink } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "";
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const resend = async () => {
    if (!email) { setError("No email on record — go back and enter it again."); return; }
    setBusy(true); setError("");
    try {
      await magicLink(email);
      setSent(true);
    } catch (err) { setError(formatAuthError(err)); }
    finally { setBusy(false); }
  };

  return (
    <AuthCard
      title="Check your inbox"
      subtitle={email ? `We sent a sign-in link to ${email}` : "We sent a sign-in link to your email"}
      footer={<AuthLink to="/auth/login" testid="magic-link-back-login">Back to login</AuthLink>}
    >
      <p className="text-xs text-center mb-6" style={{ color: "#9a9a9a" }}>
        The link expires in 10 minutes and can only be used once.
      </p>
      <AuthButton variant="charcoal" onClick={resend} loading={busy} testid="magic-link-resend">
        {sent ? "Resend link" : "Resend link"}
      </AuthButton>
      {sent && !error && (
        <p className="text-xs text-center mt-4" style={{ color: "#a8dca8" }} data-testid="magic-link-resent">
          Sent again — check your inbox.
        </p>
      )}
      {error && (
        <p className="text-xs text-center mt-4" style={{ color: "#c86a6a" }} data-testid="magic-link-error">
          {error}
        </p>
      )}
      <div className="mt-4">
        <AuthButton variant="charcoal" onClick={() => navigate("/auth/login")} testid="magic-link-back-btn">
          Back to login
        </AuthButton>
      </div>
    </AuthCard>
  );
}
